<template>
    <div class="sales-filter-projects">
        <div class="container">
            <div class="filter-container" v-click-outside="onClickOutside" :class="{'openMobile': isOpenFilterMobile}">
                <div class="mobile-filter-header" v-if="isMobileChecker">
                    <h2><span>{{ filterCMSparams.words_translation.filter_title_filter_mobile }}</span></h2>
                    <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                </div>

                <div class="btns-in-sales-filter" :class="{'btns-in-sales-filter-kz': globalLang == 'kz/'}">
                    <div class="btn-category-nav">
                        <ul>
                            <li :class="{'active': filterSalesDataBase.availableForSale == true}" @click="reloadFilter(), setDataInSalesDataBase('availableForSales', true)"><span>{{ filterCMSparams.words_translation.filter_btn_available_sale }}</span></li>
                            <li :class="{'active': filterSalesDataBase.availableForSale == false}" @click="reloadFilter(), setDataInSalesDataBase('availableForSales', false)"><span>{{ filterCMSparams.words_translation.filter_btn_available_sale_false }}</span></li>
                        </ul>
                    </div>
                </div>
                <!-- FILTER LOCATION -->
                <div class="dropwdown-filter-select dropwdown-disctricts" :class="{'dropwdown-filter-select-kz': globalLang == 'kz/'}">
                    <div class="drop-filter-name" :class="{'open' : open_dropDistrict}">
                        <a href="#" @click.prevent="open_dropDistrict = !open_dropDistrict, open_dropFlatParams = false, open_droPrice = false">{{filterCMSparams.sales_filter.location_filter_params.name}}</a>
                        <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                    </div>
                    <div class="dropdown-menu" :class="{'open' : open_dropDistrict}">
                        <div class="mobile-filter-drop-header" v-if="isMobileChecker">
                            <a href="#" class="close-arrow" @click.prevent="open_dropDistrict = !open_dropDistrict"><svgIcon name="arrow-drop" class="icon-svg"/></a>
                            <h2>{{filterCMSparams.sales_filter.location_filter_params.name}}</h2>
                            <a href="#" class="close-link" @click.prevent="closeMobileFilter"><svgIcon name="close" class="icon-svg"/></a>
                        </div>
                        <div class="btn-save" v-if="isMobileChecker">
                            <a href="#" @click.prevent="open_dropDistrict = !open_dropDistrict"><span>{{ filterCMSparams.words_translation.filter_btn_save_mobile }}</span></a>
                        </div>
                        <div class="drop-category-nav">
                            <ul>
                                <li :class="{'active': filterSalesDataBase.location_type == 'all'}" @click="setDataInSalesDataBase('location_type', 'all')"><span>{{ filterCMSparams.words_translation.filter_btn_all }}</span></li>
                                <li :class="{'active': filterSalesDataBase.location_type == 'district'}" @click="setDataInSalesDataBase('location_type', 'district')"><span>{{ filterCMSparams.words_translation.filter_btn_district }}</span></li>
                                <li :class="{'active': filterSalesDataBase.location_type == 'metro'}" @click="setDataInSalesDataBase('location_type', 'metro')"><span>{{ filterCMSparams.words_translation.filter_btn_metro }}</span></li>
                            </ul>
                        </div>
                        <simplebar data-simplebar-auto-hide="false" class="dropdown-scroll-container">
                            <div class="drop-checkbox-container">
                                <!-- РАЙОНЫ -->
                                <div class="item-R" v-for="item in filterCMSparams.sales_filter.location_filter_params.almaty_district" v-if="filterSalesDataBase.location_type == 'all' || filterSalesDataBase.location_type == 'district'">
                                    <input type="checkbox" :id="item.slug" :value="item.slug" v-model="filterSalesDataBase.disctrictChecked" @change="filterSalesItems()"> 
                                    <label :for="item.slug">{{item.name}}</label>
                                </div>
                                <!-- METRO -->
                                <div class="item-R" v-for="item in filterCMSparams.sales_filter.location_filter_params.almaty_metro" v-if="filterSalesDataBase.location_type == 'all' || filterSalesDataBase.location_type == 'metro'">
                                    <input type="checkbox" :id="'metro_' + item.slug" :value="item.slug" v-model="filterSalesDataBase.metroChecked" @change="filterSalesItems()"> 
                                    <label :for="'metro_' + item.slug">{{item.name}}</label>
                                    <img src="https://dialgroup.kz/cms/media/almaty_metro_logo_v2.svg" alt="" class="metro-icon">
                                </div>
                                <!-- end metro -->
                            </div>
                        </simplebar>
                    </div>
                </div>
                <!-- END FILTER LOCATION -->
                <!-- FILTER FLATS PARAMS -->
                <div class="dropwdown-filter-select dropwdown-flats-params">
                    <div class="drop-filter-name" :class="{'open' : open_dropFlatParams}">
                        <a href="#" @click.prevent="open_dropFlatParams = !open_dropFlatParams, open_dropDistrict = false, open_droPrice = false">{{filterCMSparams.sales_filter.flats_filter_params.name}}</a>
                        <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                    </div>
                    <div class="dropdown-menu" :class="{'open' : open_dropFlatParams}">
                        <div class="drop-category-nav">
                            <ul>
                                <li :class="{'active': filterSalesDataBase.segment_type == 'all'}" @click="setDataInSalesDataBase('segment_type', 'all')"><span>{{ filterCMSparams.words_translation.filter_btn_all }}</span></li>
                                <li :class="{'active': filterSalesDataBase.segment_type == item.slug}" v-for="item in filterCMSparams.sales_filter.flats_filter_params.segment" @click="setDataInSalesDataBase('segment_type', item.slug)"><span>{{ item.name }}</span></li>
                            </ul>
                        </div>
                        <div class="drop-filter-item drop-filter-rooms">
                            <span>{{filterCMSparams.sales_filter.flats_filter_params.rooms_filter.name}}</span>
                            <div class="filter room-items">
                                <div class="item-R" v-for="item in rooms_filter_arr">
                                    <input type="checkbox" :id="'room_' + item" :value="item" v-model="filterSalesDataBase.roomQuantities" @change="setDataInSalesDataBase('unAvailableForSaleReset', true), filterSalesItems()">
                                    <label :for="'room_' + item">{{item}}</label>
                                </div>
                            </div>
                        </div>
                        <div class="drop-filter-item drop-filter-size">
                            <span>{{filterCMSparams.sales_filter.flats_filter_params.size_filter.name}}</span>
                            <div class="filter size-filter range-filter" v-if="filterSalesDataBase.initRangeSliders">
                                <div class="filter-inputs filter-inputs-size">
                                    <div class="input-item">
                                        <span class="start">от</span>
                                        <input type="number" name="minSize" class="form-control" v-model.lazy="filterSalesDataBase.size[0]" @focusout="validateInput" @keyup.enter="validateInput">
                                        <span class="end">м²</span>
                                    </div>
                                    <div class="input-item">
                                        <span class="start">до</span>
                                        <input type="number" name="maxSize" class="form-control" v-model.lazy="filterSalesDataBase.size[1]" @focusout="validateInput" @keyup.enter="validateInput">
                                        <span class="end">м²</span>
                                    </div>
                                </div>
                                <div class="filter-range-slider">
                                    <vue-slider v-model="filterSalesDataBase.size" :enable-cross="false" :order="true" :silent="true" :min="parseInt(filterCMSparams.sales_filter.flats_filter_params.size_filter.min_size)" :max="parseInt(filterCMSparams.sales_filter.flats_filter_params.size_filter.max_size)" :interval="intervalSize" @change="setDataInSalesDataBase('unAvailableForSaleReset', true), filterSalesItems()"/>
                                </div>
                            </div>
                        </div>
                        <div class="drop-filter-item drop-filter-floor">
                            <span>{{filterCMSparams.sales_filter.flats_filter_params.floor_filter.name}}</span>
                            <div class="filter floor-filter range-filter" v-if="filterSalesDataBase.initRangeSliders">
                                <div class="filter-inputs filter-inputs-floor">
                                    <div class="input-item">
                                        <span class="start">от</span>
                                        <input type="number" name="minFloor" class="form-control" v-model.lazy="filterSalesDataBase.floor[0]" @focusout="validateInput" @keyup.enter="validateInput">
                                    </div>
                                    <div class="input-item">
                                        <span class="start">до</span>
                                        <input type="number" name="maxFloor" class="form-control" v-model.lazy="filterSalesDataBase.floor[1]" @focusout="validateInput" @keyup.enter="validateInput">
                                    </div>
                                </div>
                                <div class="filter-range-slider">
                                    <vue-slider v-model="filterSalesDataBase.floor" :enable-cross="false" :order="true" :silent="true" :min="parseInt(filterCMSparams.sales_filter.flats_filter_params.floor_filter.min_floor)" :max="parseInt(filterCMSparams.sales_filter.flats_filter_params.floor_filter.max_floor)" :interval="intervalFloor" @change="setDataInSalesDataBase('unAvailableForSaleReset', true), filterSalesItems()"/>
                                </div>
                            </div>
                        </div>
                        <div class="drop-filter-item drop-filter-finish">
                            <span>{{filterCMSparams.sales_filter.flats_filter_params.finish_filter.name}}</span>
                            <div class="btns-filter">
                                <ul>
                                    <li :class="{'active': filterSalesDataBase.finish == 'not'}" @click="setDataInSalesDataBase('finish', 'not'), setDataInSalesDataBase('unAvailableForSaleReset', true), filterSalesItems()">{{ filterCMSparams.sales_filter.flats_filter_params.finish_filter.not }}</li>
                                    <li :class="{'active': filterSalesDataBase.finish == 'has'}" @click="setDataInSalesDataBase('finish', 'has'), setDataInSalesDataBase('unAvailableForSaleReset', true), filterSalesItems()">{{ filterCMSparams.sales_filter.flats_filter_params.finish_filter.has }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END FILTER FLATS PARAMS -->
                <!-- FILTER PRICE -->
                <div class="dropwdown-filter-select dropwdown-price">
                    <div class="drop-filter-name" :class="{'open' : open_droPrice}">
                        <a href="#" @click.prevent="open_droPrice = !open_droPrice, open_dropFlatParams = false, open_dropDistrict = false">{{filterCMSparams.sales_filter.price_filter_params.name}}</a>
                        <div class="drop-icon"><svgIcon name="arrow-drop" class="icon-svg"/></div>
                    </div>
                    <div class="dropdown-menu" :class="{'open' : open_droPrice}">
                        <div class="drop-filter-item drop-filter-price">
                            <span>{{filterCMSparams.sales_filter.price_filter_params.price_filter.name}}</span>
                            <div class="filter size-filter range-filter" v-if="filterSalesDataBase.initRangeSliders">
                                <div class="filter-inputs filter-inputs-price">
                                    <div class="input-item">
                                        <span class="start">от</span>
                                        <input type="number" name="minPrice" class="form-control" v-model.lazy="filterSalesDataBase.price[0]" @focusout="validateInput" @keyup.enter="validateInput">
                                        <span class="end">млн</span>
                                    </div>
                                    <div class="input-item">
                                        <span class="start">до</span>
                                        <input type="number" name="maxPrice" class="form-control" v-model.lazy="filterSalesDataBase.price[1]" @focusout="validateInput" @keyup.enter="validateInput">
                                        <span class="end">млн</span>
                                    </div>
                                </div>
                                <div class="filter-range-slider">
                                    <vue-slider v-model="filterSalesDataBase.price" :enable-cross="false" :order="true" :silent="true" :min="parseInt(filterCMSparams.sales_filter.price_filter_params.price_filter.min_price)" :max="parseInt(filterCMSparams.sales_filter.price_filter_params.price_filter.max_price)" :interval="intervalSize" @change="setDataInSalesDataBase('unAvailableForSaleReset', true), filterSalesItems()"/>
                                </div>
                            </div>
                            <div class="actions-filter">
                                <div class="drop-checkbox-single">
                                    <div class="item-check">
                                        <input type="checkbox" id="actions_btn" v-model="filterSalesDataBase.actions" @change="setDataInSalesDataBase('unAvailableForSaleReset', true), filterSalesItems()"> 
                                        <label for="actions_btn">{{filterCMSparams.sales_filter.price_filter_params.price_sales_btn_desc}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END FILTER PRICE -->
                <!-- RESET FILTER BTN -->
                <div class="btn-reset-filter" @click.prevent="reloadFilter" v-if="!isMobileChecker">
                    <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                    <svgIcon name="close-filter" class="icon-close"/>
                </div>
                <!-- END RESET -->
                <div class="btn-find-info" v-if="isMobileChecker">
                    <a href="#" @click.prevent="closeMobileFilter">
                        <strong>Найдено {{ filterSalesDataBase.filter_items_count }} 
                            <span v-if="filterSalesDataBase.filter_items_count == 1">проект</span>
                            <span v-if="filterSalesDataBase.filter_items_count == 2 || filterSalesDataBase.filter_items_count == 3 || filterSalesDataBase.filter_items_count == 4">проекта</span>
                            <span v-if="filterSalesDataBase.filter_items_count > 4">проектов</span>
                        </strong> 
                    </a>
                </div>
            </div>
            <div class="mobile-filter-container" v-if="isMobileChecker">
                <div class="mobile-filter-btns">
                    <a href="#" @click.prevent="openMobileFilter" class="link-mobile-open-sales-filter">
                        <span>{{ filterCMSparams.sales_filter.btn_filter_mobile_name }}</span>
                        <svgIcon name="filter" class="icon-svg"/>
                    </a>
                    <a href="#"
                        v-scroll-to="{
                            el: '#home-sales-map-section',
                            offset: -100
                        }"
                        class="link-mobile-open-map-sales"
                    >
                        <span>{{ filterCMSparams.sales_filter.btn_map_mobile_name }}</span>
                        <svgIcon name="marker-filter" class="icon-svg"/>
                    </a>
                </div>
                <div class="btns-bottom-controls">
                    <strong>Найдено {{ filterSalesDataBase.filter_items_count }} 
                        <span v-if="filterSalesDataBase.filter_items_count == 1">проект</span>
                        <span v-if="filterSalesDataBase.filter_items_count == 2 || filterSalesDataBase.filter_items_count == 3 || filterSalesDataBase.filter_items_count == 4">проекта</span>
                        <span v-if="filterSalesDataBase.filter_items_count > 4">проектов</span>
                    </strong> 
                    <div class="btn-reset-filter-mobile" @click.prevent="reloadFilter">
                        <span>{{ filterCMSparams.words_translation.filter_btn_clearfilter }}</span>
                        <svgIcon name="close-filter" class="icon-close"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import salesFilterCount from '@/components/filters/sales-projects/sales-filter-counter.vue'
    import simplebar from 'simplebar-vue';
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'
    import 'simplebar-vue/dist/simplebar.min.css';
    import {mapGetters} from 'vuex'
    export default {
        name: 'sales-filter-projects',
        components: {
            svgIcon,
            simplebar,
            VueSlider,
            salesFilterCount,
            // vueCustomScrollbar,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                routerName: this.$router.history.current.name,
                open_dropDistrict: false,
                open_dropFlatParams: false,
                open_droPrice: false,
                settings: {
                    wheelPropagation: true,
                    minScrollbarLength: 140,
                    maxScrollbarLength: 140,
                    suppressScrollY: false
                },
                intervalSize: 1,
                intervalFloor: 1,
                rooms_filter_arr: ['ст', '1', '2', '3', '4'],
                initRangeSlider: false,
            }
        },
        computed: mapGetters({
            salesItems: 'loadSalesItemsDefault',
            isMobileChecker: 'loadIsMobileChecker',
            //
            filterCMSparams: 'loadFilterCMSparams',
            filterSalesDataBase: 'loadFilterSalesData',
            isOpenFilterMobile: 'loadOpenMobileFilter',
        }),
        methods: {
            setDataInSalesDataBase(param, data) {
                this.$store.commit('FilterSales_update_base', {name: param, data: data});
                this.filterSalesItems();
            },
            onClickOutside() {
                this.open_dropDistrict = false;
                this.open_dropFlatParams = false;
                this.open_droPrice = false;
            },
            validateInput(e) {
                this.setDataInSalesDataBase('unAvailableForSaleReset', true);
                const minSize_default = parseInt(this.filterCMSparams.sales_filter.flats_filter_params.size_filter.min_size);
                const maxSize_default = parseInt(this.filterCMSparams.sales_filter.flats_filter_params.size_filter.max_size);
                const minFloor_default = parseInt(this.filterCMSparams.sales_filter.flats_filter_params.floor_filter.min_floor);
                const maxFloor_default = parseInt(this.filterCMSparams.sales_filter.flats_filter_params.floor_filter.max_floor);
                const minPrice_default = parseInt(this.filterCMSparams.sales_filter.price_filter_params.price_filter.min_price);
                const maxPrice_default = parseInt(this.filterCMSparams.sales_filter.price_filter_params.price_filter.max_price);
                // console.log(e.target.value, e.target.name, 8888);
                //--// -- CHECK FOR SIZE FILTER RANGE
                if (e.target.name == 'minSize') {
                    if (parseInt(e.target.value) < minSize_default) {
                        e.target.value = minSize_default;
                        this.$store.commit('FilterSales_update_base', {name: 'sizeUpdate', param: 'min', data: minSize_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterSalesDataBase.size[1]) {
                        e.target.value = this.filterSalesDataBase.size[1];
                        this.$store.commit('FilterSales_update_base', {name: 'sizeUpdate', param: 'min_max', data: this.filterSalesDataBase.size[1]});
                    }
                } else if (e.target.name == 'maxSize') {
                    if (parseInt(e.target.value) > maxSize_default) {
                        e.target.value = maxSize_default;
                        this.$store.commit('FilterSales_update_base', {name: 'sizeUpdate', param: 'max', data: maxSize_default});
                    } else if (parseInt(e.target.value) < this.filterSalesDataBase.size[0]) {
                        e.target.value = this.filterSalesDataBase.size[0];
                        this.$store.commit('FilterSales_update_base', {name: 'sizeUpdate', param: 'max_max', data: this.filterSalesDataBase.size[0]});
                    }
                } 
                //--//-- CHECK FOR FLOOR FILTER RANGE
                else if (e.target.name == 'minFloor') {
                    if (parseInt(e.target.value) < minFloor_default) {
                        e.target.value = minFloor_default;
                        this.$store.commit('FilterSales_update_base', {name: 'floorUpdate', param: 'min', data: minFloor_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterSalesDataBase.floor[1]) {
                        e.target.value = this.filterSalesDataBase.floor[1];
                        this.$store.commit('FilterSales_update_base', {name: 'floorUpdate', param: 'min_max', data: this.filterSalesDataBase.floor[1]});
                    } 
                }
                else if (e.target.name == 'maxFloor') {
                    if (parseInt(e.target.value) > maxFloor_default) {
                        e.target.value = maxFloor_default;
                        this.$store.commit('FilterSales_update_base', {name: 'floorUpdate', param: 'max', data: maxFloor_default});
                    } else if (parseInt(e.target.value) < this.filterSalesDataBase.floor[0]) {
                        e.target.value = this.filterSalesDataBase.floor[0];
                        this.$store.commit('FilterSales_update_base', {name: 'floorUpdate', param: 'max_max', data: this.filterSalesDataBase.floor[0]});
                    }
                }
                //--//-- CHECK FOR PRICE FILTER RANGE
                else if (e.target.name == 'minPrice') {
                    if (parseInt(e.target.value) < minPrice_default) {
                        e.target.value = minPrice_default;
                        this.$store.commit('FilterSales_update_base', {name: 'priceUpdate', param: 'min', data: minPrice_default});
                    } 
                    else if (parseInt(e.target.value) > this.filterSalesDataBase.price[1]) {
                        e.target.value = this.filterSalesDataBase.price[1];
                        this.$store.commit('FilterSales_update_base', {name: 'priceUpdate', param: 'min_max', data: this.filterSalesDataBase.price[1]});
                    } 
                }
                else if (e.target.name == 'maxPrice') {
                    if (parseInt(e.target.value) > maxPrice_default) {
                        e.target.value = maxPrice_default;
                        this.$store.commit('FilterSales_update_base', {name: 'priceUpdate', param: 'max', data: maxPrice_default});
                    } else if (parseInt(e.target.value) < this.filterSalesDataBase.price[0]) {
                        e.target.value = this.filterSalesDataBase.price[0];
                        this.$store.commit('FilterSales_update_base', {name: 'priceUpdate', param: 'max_max', data: this.filterSalesDataBase.price[0]});
                    }
                }

                this.filterSalesItems();
            },
            filterSalesItems() {
                var salesItems = this.salesItems;
                const filteredData = salesItems.filter(item => {
                    const isAvailableForSale = this.filterSalesDataBase.availableForSale;
                    const unAvailableForSaleReset = this.filterSalesDataBase.unAvailableForSaleReset;
                    if (!isAvailableForSale && !item.filter_params.available_sale) {
                        // Если фильтр availableForSale установлен в false и available_sale объекта тоже false,
                        // возвращаем объект без учета остальных фильтров, если unAvailableForSaleReset равен false
                        if (!unAvailableForSaleReset) {
                            return (
                                (!this.filterSalesDataBase.disctrictChecked.length || this.filterSalesDataBase.disctrictChecked.includes(item.filter_params.district.slug)) &&
                                (!this.filterSalesDataBase.metroChecked.length || this.filterSalesDataBase.metroChecked.includes(item.filter_params.metro.slug)) &&
                                (this.filterSalesDataBase.segment_type === 'all' ? true : item.filter_params.segment.slug == this.filterSalesDataBase.segment_type)
                            );
                        }
                    }
                    return (
                        (isAvailableForSale ? item.filter_params.available_sale == true : true) &&
                        (!this.filterSalesDataBase.disctrictChecked.length || this.filterSalesDataBase.disctrictChecked.includes(item.filter_params.district.slug)) &&
                        (!this.filterSalesDataBase.metroChecked.length || this.filterSalesDataBase.metroChecked.includes(item.filter_params.metro.slug)) &&
                        (this.filterSalesDataBase.segment_type === 'all' ? true : item.filter_params.segment.slug == this.filterSalesDataBase.segment_type) &&
                        (!this.filterSalesDataBase.roomQuantities.length || item.filter_params.rooms.some(room => this.filterSalesDataBase.roomQuantities.includes(room))) &&
                        (item.filter_params.size.some(value => parseInt(value) >= this.filterSalesDataBase.size[0] && parseInt(value) <= this.filterSalesDataBase.size[1])) &&
                        (item.filter_params.floor.some(value => parseInt(value) >= this.filterSalesDataBase.floor[0] && parseInt(value) <= this.filterSalesDataBase.floor[1])) &&
                        (this.filterSalesDataBase.finish === 'not' ? true : item.filter_params.finish == this.filterSalesDataBase.finish) &&
                        (item.filter_params.price.some(value => parseInt(value) >= this.filterSalesDataBase.price[0] && parseInt(value) <= this.filterSalesDataBase.price[1])) &&
                        (this.filterSalesDataBase.actions === false ? true : item.filter_params.actions == this.filterSalesDataBase.actions)
                    );
                });
                // console.log(filteredData, 'asdasdas')
                this.$store.commit('FilterSales_update_base', {name: 'counter', data: filteredData.length});
                this.$store.commit('animateSalesItems', false);
                this.$store.commit('updateSalesItems_filter', filteredData);
            },
            reloadFilter() {
                // console.log('reload')
                this.$store.commit('ReloadFilter');
                this.filterSalesItems();
            },  
            openMobileFilter() {
                this.$store.commit('OpenMobileFilter', true);
                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                document.getElementById('header').classList.add('hideMobile');
            },
            closeMobileFilter() {
                this.$store.commit('OpenMobileFilter', false);
                document.getElementsByTagName('body')[0].classList.remove('overlay-open');
                document.getElementById('header').classList.remove('hideMobile');
            },  
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.$store.commit('FilterSales_update_base', {name: 'counter', data: this.salesItems.length});
            this.filterSalesItems();
            // this.updateFilterSalesDataBase();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/filters/sales-projects/sales-filter.scss';
    @import '@/styles/components/filters/sales-projects/respond/sales-filter-respond.scss';
</style>